import { CollectionSpace, FieldModel, FieldsAPI, ResourceDetail } from '@cibo/core'
import { QUERY_KEY as MAPGL_QUERY_KEY } from '@cibo/mapgl'
import { logRequestError } from '@cibo/ui'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Feature } from '@turf/turf'
import { QUERY_KEY } from './queryKey'

type CreateFieldRequest = {
  description?: string
  feature: Feature
  metadata?: any
  name: string
  owner?: string
  space?: CollectionSpace
}

export const useCreateField = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ description, feature, metadata, name, space, owner }: CreateFieldRequest) => {
      const details: ResourceDetail[] = [
        { traitId: 'name', input: { name } },
        { traitId: 'geometry', input: { feature } },
      ]
      if (description) {
        details.push({ traitId: 'description', input: { description } })
      }

      const response = await FieldsAPI.create({
        details,
        metadata,
        owner,
        space,
      }).catch(error => {
        logRequestError(error)
        throw error
      })
      return new FieldModel(response.item)
    },
    {
      mutationKey: [QUERY_KEY.FIELD_CREATE],
      onSuccess: ({ owner }) => {
        queryClient.invalidateQueries([QUERY_KEY.FIELDS])
        queryClient.invalidateQueries([QUERY_KEY.FIELD_STATS])
        // Does this query invalidation cause problems? Hard to say. If so, let's fix the problems.
        // This invalidation ends up being important to presenting a appropriate fields list.
        queryClient.invalidateQueries([QUERY_KEY.FIELDS_PAGINATED])
        queryClient.invalidateQueries([QUERY_KEY.FIELDS_PAGINATED_FIELD_COUNT])
        queryClient.invalidateQueries([MAPGL_QUERY_KEY.COLLECTION_SEARCH_QUERY])
        queryClient.invalidateQueries(['org_users', owner.userId])
      },
    }
  )
}
